// pattern: functional-core

/** Returns today's date as YYYY-MM-DD in local time */
export function today(): string {
	return formatDate(new Date());
}

/** Formats a Date as YYYY-MM-DD */
export function formatDate(d: Date): string {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}

/** Validates YYYY-MM-DD format and that the date is real */
export function isValidDate(s: string): boolean {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
	const d = new Date(`${s}T00:00:00`);
	return !Number.isNaN(d.getTime()) && formatDate(d) === s;
}

/** Returns human-readable relative date: "Today", "Yesterday", "Mon Apr 7", etc. */
export function relativeDate(dateStr: string): string {
	const t = today();
	if (dateStr === t) return "Today";

	const d = new Date(`${t}T00:00:00`);
	d.setDate(d.getDate() - 1);
	if (dateStr === formatDate(d)) return "Yesterday";

	const target = new Date(`${dateStr}T00:00:00`);
	return target.toLocaleDateString("en-US", {
		weekday: "short",
		month: "short",
		day: "numeric",
	});
}
